// extracted by mini-css-extract-plugin
export var compact = "_mj-2";
export var phoneFrame = "_mj-0";
export var phoneScreen = "_mj-1";